import React, { Component } from 'react';

class SelectFilterMovies extends Component {

    showDataFilter = datas => {
        let result = null;
        if (datas.length) {
            result = datas.map((data, index) => {
                return (
                    <option key={ index } value={ data._id }>{ data.name }</option>
                );
            });
        }
        return result;
    }

    onChangeFilter = (e) => {
        this.props.onChangeFilter(e);
    }

    render() {
        
        let { dataFilter, defaultDisplay, valueFilter, nameFilter } = this.props;

        return (
            <select 
                className="slect"
                onChange={ this.onChangeFilter }
                value={ valueFilter }
                name={ nameFilter }
            >
                <option value="">{ defaultDisplay }</option>
                { this.showDataFilter(dataFilter) }
            </select>
        );
    }

}

export default SelectFilterMovies;



// WEBPACK FOOTER //
// ./src/components/MoviePageComponent/SelectFilterMovies.js